import "./artist_social";

import { Icon } from "@components/icon";
import { MauSocialLink } from "@components/mau_social_link/mau_social_link";
import * as types from "@root/types";
import React, { FC } from "react";

interface ArtistSocialProps {
  artist: types.Artist;
}

const ArtistSocial: FC<ArtistSocialProps> = ({ artist }) => {
  if (!artist) {
    return null;
  }

  return (
    <div className="artist-social">
      {artist.website ? (
        <div className="artist-social--website">
          <a href={artist.website} aria-label="My Website" title="My Website">
            {artist.website}
          </a>
        </div>
      ) : null}
      <div className="artist-social--icons">
        {artist.login && artist.name && (
          <MauSocialLink login={artist.login} name={artist.name} />
        )}
        {artist.facebook ? (
          <a href={artist.facebook} aria-label="Facebook" title="Facebook">
            <Icon
              ariaLabel={`Visit ${artist.name} on Facebook`}
              name="facebook2"
            />
          </a>
        ) : null}
        {artist.instagram ? (
          <a href={artist.instagram} aria-label="Instagram" title="Instagram">
            <Icon
              ariaLabel={`Visit ${artist.name} on Instagram`}
              name="instagram"
            />
          </a>
        ) : null}
      </div>
    </div>
  );
};

export { ArtistSocial, ArtistSocialProps };
